export enum OfflineLevelEnum {
    Online = 1,
    BadConnectionDetected = 2,
    Offline = 3,
}
